// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"src_bootstrap_js-src_app_css":"55960f7cb37c480d8ea4","vendors-node_modules_saas-ui-design_dist_index_js":"7f5163abd9c4209e52ec"}[chunkId] + ".css";
};